const checkUppercase = (str: string): boolean => {
  for (let i = 0; i < str.length; i++) {
    if (str.charAt(i) === str.charAt(i).toUpperCase() && str.charAt(i).match(/[a-z]/i)) {
      return true;
    }
  }
  return false;
};

export const validPassword = (password: string): boolean => {
  const isUpperCase = checkUppercase(password);
  if (password && password.length >= 8 && isUpperCase) {
    return true;
  } else {
    return false;
  }
};
